"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("title", {
      children: "Artboard"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M21.42 21.92c-1.857 0-3.363-1.49-3.363-3.327 0-1.839 1.506-3.329 3.364-3.329 1.857 0 3.363 1.49 3.363 3.329 0 1.838-1.506 3.328-3.363 3.328m1.007-9.736v-2.96a2.277 2.277 0 001.328-2.055v-.068c0-1.253-1.036-2.277-2.301-2.277h-.069c-1.265 0-2.3 1.024-2.3 2.277v.068c0 .907.547 1.69 1.328 2.054v2.96a6.556 6.556 0 00-3.102 1.352L9.098 7.212c.054-.206.092-.418.092-.64C9.191 5.152 8.032 4.001 6.598 4 5.165 3.998 4.002 5.147 4 6.565c-.002 1.418 1.158 2.57 2.592 2.571.467 0 .9-.13 1.278-.344l8.08 6.22a6.412 6.412 0 00-1.09 3.58c0 1.386.443 2.668 1.19 3.722l-2.457 2.432a2.122 2.122 0 00-.609-.098 2.121 2.121 0 00-2.132 2.11c0 1.166.954 2.11 2.132 2.11a2.121 2.121 0 002.133-2.11c0-.21-.041-.41-.1-.602l2.431-2.406a6.57 6.57 0 003.973 1.334c3.623 0 6.56-2.906 6.56-6.491 0-3.246-2.41-5.927-5.553-6.408",
      fill: "#FF7A59",
      fillRule: "nonzero"
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Hubspot.js.map